import { useHubTableContext } from "../hub-table.context";
import styles from "../hub-table.module.scss";

/** Texto do carregamento só para leitor de tela (o spinner é o overlay do `DataTable`). */
export function HubTableLoadingAnnouncement() {
  const { announceLoading, loadingLabel, partTestId } = useHubTableContext();

  return announceLoading ? (
    <span className={styles.srOnly} role="status" data-testid={partTestId("loading")}>
      {loadingLabel}
    </span>
  ) : null;
}
HubTableLoadingAnnouncement.displayName = "HubTable.LoadingAnnouncement";
